import { useEffect } from 'react'

const useProductFieldsController = ({
  byMakeName,
  byCategoryId,
  byModelName,
  byGenerationName,
  bySeriesName,
  setValue
}: {
  byMakeName?: string
  byCategoryId?: string
  byModelName?: string
  byGenerationName?: string
  bySeriesName?: string
  setValue: (key: string, value: string | number | null) => void
}) => {
  useEffect(() => {
    if (!byMakeName) {
      setValue('by_model_name', null)
    }
  }, [byMakeName])

  useEffect(() => {
    if (!byCategoryId) {
      setValue('by_sub_category_id', null)
    }
  }, [byCategoryId])

  useEffect(() => {
    if (!byModelName) {
      setValue('by_generation_name', null)
    }
  }, [byModelName])

  useEffect(() => {
    if (!byGenerationName) {
      setValue('by_serie_name', null)
    }
  }, [byGenerationName])

  useEffect(() => {
    if (!bySeriesName) {
      setValue('by_trim_name', null)
    }
  }, [bySeriesName])
}

export default useProductFieldsController
